var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoingofflineBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.05,379.4s20.2-33.15-13.83-104.8-64.61-71.69-106.36-114.12-61.69-92-125.5-94.32-115.94,21-124.45,68.7-1.57,45.45-57.15,66.39S8.49,288.57,18.06,316.52s6.38,41.92,0,60.55,9.57,33.77,24.47,48.9,62.75,32.61,114.86,26.79S240.53,413.67,268,417.82s81.9,39.59,127.63,32.61S479.67,428.3,486.05,379.4Z",
    style: {
      fill: "#C026D3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.05,379.4s20.2-33.15-13.83-104.8-64.61-71.69-106.36-114.12-61.69-92-125.5-94.32-115.94,21-124.45,68.7-1.57,45.45-57.15,66.39S8.49,288.57,18.06,316.52s6.38,41.92,0,60.55,9.57,33.77,24.47,48.9,62.75,32.61,114.86,26.79S240.53,413.67,268,417.82s81.9,39.59,127.63,32.61S479.67,428.3,486.05,379.4Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tree--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.92,42v9l-5,22-7-30-1,11V65c0,6-3,29-3,29V77l-7-25V65l2,31L454,60l-1,6V95c0,4-8,26-8,26l2-21-9-34V89c0,3-6,28-6,28s-2-10-2-17-2-32-2-32-3,25-6,33-15,29-15,29,4-14,6-20S414,78,414,78s-7,10-8,20-17,36-17,36,6-16,6-21,5-32,5-32-15,24-16,30-23,22-23,22,13-20,17-27a119.89,119.89,0,0,0,7-15s-14,17-24,27-37.94,18-37.94,18L376.07,93s-12.4,8-23.31,14.81c-7.15,4.44-13.66,8.36-15.63,9.15-5,2-37.95,24-37.95,24s26-24,36.95-33,39.94-22,39.94-22-30,14-40.94,15-31,15-31,15,16-18,30-21,51.93-20,51.93-20l-23,1-18,6-3.9,1.3L315.16,92s45.93-24,55.92-26S412,65,412,65l-31.95-7-46.94,9s37.95-14,42.94-15S414,51,414,51l-15-1-53.92-5S400,39,409,40,447,50,447,50s-14-9-29-12a131.88,131.88,0,0,1-29-10s26,4,42.94,6,21,9,21,9l-14-17-10-5s24,13,27,15,7,5,7,5-6-7-9-11-11-11-11-11,20,15,23,15,4,3,4,3l-10-16,17,8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.35,60.7l4.19,6.5,6.63,18.23L474.14,67l4.4,8.41,5.12,8c2.8,4.34,11.34,22.36,11.34,22.36l-7.92-12.29-16.7-14.8,3.73,5.78L476.44,88l15.88,21.48-22.55-22.3,2.07,4.8s11.64,18.07,13.51,21,6.32,22.52,6.32,22.52l-8.33-16.11L461,99s9.31,14.46,10.71,16.62,8.71,23,8.71,23a93.21,93.21,0,0,1-9.37-11.36c-3.26-5.06-16.35-22.2-16.35-22.2s9.48,19.47,11,26.65,2.66,27.94,2.66,27.94-3.63-12-5-17.24-14.18-23.6-14.18-23.6-.4,10.49,3.53,18.18S457.25,171,457.25,171s-3.11-14.36-5.44-18-11.29-25.46-11.29-25.46.34,24.33,2.41,29.13-6.38,26.62-6.38,26.62.08-20.51-.29-27.44a103.4,103.4,0,0,0-1.92-14.1s-2.21,18.81-4.78,30.69-19.08,30.71-19.08,30.71l18.28-55.76S423.53,159,418.8,169c-3.1,6.56-6,12.43-7.05,13.92-2.68,3.77-16.29,35-16.29,35s7.62-29.45,11.38-41.08,18.66-34.53,18.66-34.53-15.16,24.09-22.65,29.94-15.42,25.28-15.42,25.28,3.19-20.47,11.91-29.15,28.27-38.68,28.27-38.68l-16.16,11.44-10.22,12.72L399,156.63l-14.81,18.45s22.07-38.77,28.36-44.88,29.17-19.81,29.17-19.81l-26.39,9.84-29.78,28.39s20.95-27.81,24.1-30.86,27-18.42,27-18.42l-11.31,6.26L384,127.13s37-29.95,43.93-33.42,32.12-10.47,32.12-10.47-14.31,0-26.55,4.84a113.79,113.79,0,0,1-25.61,6.27s20.65-9.21,33.87-15.68,19.37-3.28,19.37-3.28l-18-5.77-9.55,1s23.4-1.78,26.5-1.74,7.39.36,7.39.36-7.6-2.27-11.63-3.76-13.08-2.83-13.08-2.83,21.45,1.53,23.61.13a3.83,3.83,0,0,1,4.29.31l-14.68-6.91,16-2.14Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.54,261.14a24.15,24.15,0,0,0-2.82,3.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,341.7h97.24s3.31-9.94-8.84-16.56-17.67-1.11-22.09-6.63,12.15-19.88-21-34.24c0,0-2.21-30.93-47.5-32-13.59-.33-22,2.32-27.47,6.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.31,
    y1: 341.7,
    x2: 204.5,
    y2: 341.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.66,
    y1: 341.7,
    x2: 159.99,
    y2: 341.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.82,280c-1.38,4.71-2.88,8.77-6.28,10.94-12.15,7.73-15.46-4.42-27.61,3.31s-6.63,23.2-16.57,25.4-23.19-9.94-35.34-2.2-12.15,14.35-17.67,14.35-16.57-4.41-23.2,0-14.36,9.94-14.36,9.94H74.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.46,98.66c-1.42-1.46-3.87-2.81-8.12-2.92-9.55-.23-7,6.53-9.55,8.16s-3.26-.93-5.82.7-1.4,4.89-3.5,5.36-4.89-2.1-7.45-.47-2.57,3-3.73,3-3.5-.93-4.89,0-3,2.1-3,2.1h25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.09,102.83l-.73-.33a6.3,6.3,0,0,0-.86-2.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.59,114.62h30.72s.7-2.1-1.86-3.5-3.73-.23-4.66-1.4,1.85-3.55-2.49-6.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.17,116.84c-1.41-1.47-3.86-2.82-8.11-2.92-9.55-.23-7,6.52-9.55,8.15s-3.26-.93-5.83.7-1.4,4.9-3.49,5.36-4.89-2.1-7.46-.46-2.56,3-3.73,3-3.49-.93-4.89,0-3,2.1-3,2.1h25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.8,121l-.72-.33a6.25,6.25,0,0,0-.86-2.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3,132.79H111s.7-2.1-1.86-3.49-3.73-.24-4.66-1.4,1.85-3.55-2.49-6.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.94,114.62h60.92s2.08-6.23-5.54-10.38-11.07-.69-13.84-4.15,7.62-12.46-13.14-21.46c0,0-1.39-19.37-29.76-20.06-12.24-.3-17.78,3.27-20.74,7.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.35,
    y1: 114.62,
    x2: 305.49,
    y2: 114.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.15,75.93c-.87,2.95-1.81,5.5-3.94,6.86-7.61,4.84-9.68-2.77-17.3,2.07s-4.15,14.53-10.38,15.92S242,94.55,234.39,99.39s-7.61,9-11.07,9-10.38-2.77-14.53,0-9,6.23-9,6.23H277.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.57,436.31c3.35.14,5.31.26,7.27.26h10.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.84,437.93c17.46.12,33.08.55,44.67,0,13.33-.67,52.66-6.67,80-6.67s68.66,0,102.66,4,46.67.67,70,.67c7.51,0,13.08.07,17.35.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.84,439.23s26-.66,45.33-.66,20-.67,40.67-.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.91,449.48c4.48.28,7.26.42,7.26.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.51,449.9s6,0,37.33-1.33,56-5.34,77.33-2.67c11.47,1.43,24.48,2.48,34.06,3.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.51,442.57s-13.34,1.33-44-.67-36.67.67-40.67.67h-10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.18,451.48a140.12,140.12,0,0,0-16.67,1.09c-14.67,2-25.34,4-31.34,4.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.51,451.9s-3.5-.24-8.65-.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.18,457.62c5.17.14,8.66.28,8.66.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.84,459.23a166.11,166.11,0,0,1,26-2c5.07,0,10.46.08,15.34.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.19,262.06s-15.55-14-21.25-12.18-9.07,23.84-9.07,35.77-2.07,30.84-2.07,30.84l21.51-12.18s11.14-2.59,18.66-15.55S347.19,262.06,347.19,262.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.85,378.06s-23.58,12.44-28,12.7-17.11-1.56-21.51-4.67-7.52-6.48-9.85-5.7-3.37,3.37-2.59,4.67a4.77,4.77,0,0,0,1.73,1.76s-3.79.74-3.06,4a7.39,7.39,0,0,1,.29,2.78s-1.3,3.63-.52,4.92,2.08,3.63,2.08,3.63.51,2.6,5.18,5.19a51.67,51.67,0,0,1,5.18,3.89c3.11,2.59,16.59,11.92,20.48,12.44s8-2.6,10.37-4.93,4.92-13,7.77-16.59,21.92-27.35,23.47-30.46S129.85,378.06,129.85,378.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.24,385.83s-2.85,9.08-2.07,13.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.21,417.36a4.5,4.5,0,0,1-4.5-4.5V312.53a4.5,4.5,0,0,1,9,0V412.86A4.49,4.49,0,0,1,334.21,417.36Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.51,392.9s24-7.4,37-11.5,32.69-14.06,42.75-20.76,17.89-11.18,22-19.75,7.46-17.14,7.46-25v-7.82L236.42,388.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.81,437.4a5.5,5.5,0,0,1-2.88-10.19L385.6,284.87a5.5,5.5,0,0,1,5.74,9.39L158.67,436.59A5.47,5.47,0,0,1,155.81,437.4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,333.6s-13-4.93-16.59-3.63-9.07,11.66-9.59,13-25,24.76-29.43,32.54-20,27.73-20,27.73S107.05,415.9,105,418s-6.74,1.56-9.59-.26A126.46,126.46,0,0,0,84.24,411a60.87,60.87,0,0,0-10.63-3.63,59.44,59.44,0,0,0,1,7.25c.77,3.63,1.29,6.23,5.18,9.34s8,7,12.44,9.33,8.81,6.48,14,3.62S115.6,426,116.89,425s7.52-12.18,13.48-15.81,23.21-17.5,30.21-24.76,14.25-23.33,14.25-23.33l10.11,5.7s9.59-9.33,9.59-18.4S186,333.6,186,333.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,418c-2.07,2.08-6.74,1.56-9.59-.26A126.46,126.46,0,0,0,84.24,411a33.92,33.92,0,0,0-3.54-1.49c1,2.09,2.29,4.91,3.6,7.95,2.18,5.1,6.17,12.52,10.3,17.18,3.65,2.22,7.4,4.62,11.67,2.27a19.69,19.69,0,0,0,5.37-4.84c.8-3.89,1-9.72,1-16.67,0-9.44,3.83-19.16,3.83-19.16l-.94.35c-2.92,3.87-5.08,6.63-5.08,6.63S107.05,415.9,105,418Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,357l-4.42,1.48-4.43-.3L169.5,352a20.08,20.08,0,0,1,.29,11.79c-1.77,6.79-10.32,20.35-10.32,20.35l-6.38,7.26c3-2.59,5.6-5,7.49-7,7-7.26,14.25-23.33,14.25-23.33l10.11,5.7A42.43,42.43,0,0,0,189,362C187.67,359.61,186,357,186,357Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.37,347.59s-25.92-7.51-36.8-10.62-22.55-5.71-24.63-4.67-5.18,27.73-4.66,30.33a19.51,19.51,0,0,0,1.81,4.92s24.62,10.37,34,13.74,22.29,10.11,26.43,10.11,8.56-2.86,10.11-4.41.52-20.48.52-27.22a46.77,46.77,0,0,0-1.3-11.4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.68,302s-9.59,3.37-23.33,12.7S286,334.12,280.84,338s-24.88,8-27.47,8h-7S243.26,351.48,243,365a79.1,79.1,0,0,0,4.41,25.92A195,195,0,0,1,278,381.55c18.4-4.15,46.14-17.11,60.39-27.48s18.15-14.77,21.51-21.51,5.45-10.37,4.41-18.14-12.7-13.48-20.22-14S332.68,302,332.68,302Z",
    style: {
      fill: "#C026D3",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.12,367.56a23.69,23.69,0,0,0,5.93.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.36,348.35s-1.87,5.6,16.81,13.08A117.6,117.6,0,0,0,287,366.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.89,351c3.62,1.62,10,3.48,20,3.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.9,348.62a9.1,9.1,0,0,0,1.24.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.83,333c-1.83-.75-2.71-1.23-2.71-1.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.55,338.21s3.2,5.34-18.68,2.14a135,135,0,0,1-26.13-6.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.64,258.43s-9.33,2.59-9.85,5.7-2.07,4.93-3.11,5.45-6.48-1-7.78.52-.51,6.48-.51,6.48a59.73,59.73,0,0,0-4.67,9.84c-1.55,4.67,0,5.45,1.81,6.23s6,3.11,6,3.11l1.29,9.59s-7,6.73-5.7,7.51,24.1-10.62,24.1-10.62,12.7-2.86,16.07-4.93,13-15.55,10.11-23.59-13.73-13-18.4-13.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.78,289.83s-13,4.43-17.7,4.43c-4.1,0-12.21-2.13-14.33-2.7a5,5,0,0,0,1.78,1.09c1.82.77,6,3.11,6,3.11l.13,1,16.63,6.95,1.36-.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.75,268.54l-2.33,2.59s1.55,2.08,3.37,2.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,264.91s3.89-2.59,7.52,3.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.46,279.94a9.12,9.12,0,0,0,8,2.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.45,260.51s-5.7-6-11.41-8.3-11.66-3.63-11.4-1.81,4.41,4.4,4.41,4.4-10.63-1.29-9.85,2.08,25.4,10.62,25.4,10.62-11.15,2.08-10.89,4.41,1.3,2.33,1.3,3.89-5.19,7.51-4.15,8.55,5.18-4.41,6.22-4.41,5.44-.51,5.44,5.45-3.88,8-5.44,8.29a35,35,0,0,0-5.44,2.08s6.74,2.59,10.36,2.59,13-2.59,16.59-9.59-.26-21-3.63-24.63A11.15,11.15,0,0,0,368.45,260.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,314.94s2.85-11.15,6-20.48,9.84-25.66,13.47-33.7,10.89-9.84,13.22-9.59,6.22,8.82,6,14.52-4.4,13.74-4.92,16.33-8.55,25.92-8.55,31.1-5.19,14.52-9.08,17.63",
    style: {
      fill: "#C026D3",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.59,265.69c.26-5.7-3.63-14.26-6-14.52s-9.59,1.56-13.22,9.59-10.36,24.37-13.47,33.7c-.76,2.26-1.49,4.62-2.18,6.9,1.8,4.69,5.78,14.41,8.14,15.39,2.15.9,8.54-.7,13.21-3.49,0,0,0-.09,0-.14,0-5.18,8-28.51,8.55-31.1S379.33,271.39,379.59,265.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53,379.16a4.86,4.86,0,0,1,4.61-8.15l217.62,56.83a4.87,4.87,0,1,1-2.32,9.45L180.82,380.46A4.8,4.8,0,0,1,178.53,379.16Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51,437.4a5.5,5.5,0,0,1-2.87-10.19L392.3,284.87a5.5,5.5,0,0,1,5.74,9.39L165.38,436.59A5.48,5.48,0,0,1,162.51,437.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.6,376.9a4.87,4.87,0,0,1,4.62-8.15l222.61,58.7a4.87,4.87,0,0,1-2.32,9.45L181.9,378.2A4.78,4.78,0,0,1,179.6,376.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.51,
    cy: 387.4,
    r: 2,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.51,
    cy: 431.9,
    r: 2,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.51,
    cy: 374.9,
    r: 2,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.51,
    cy: 422.4,
    r: 2,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.01,
    cy: 294.9,
    r: 2,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.51,424.07a4.5,4.5,0,0,1-4.5-4.5V319.23a4.5,4.5,0,0,1,9,0V419.57A4.51,4.51,0,0,1,346.51,424.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.51,
    cy: 417.9,
    r: 2,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.51,
    cy: 320.4,
    r: 2,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "236.51 345.23 272.51 343.23 247.17 336.9 210.17 338.23 236.51 345.23",
    style: {
      fill: "#d4d4d4",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.51 345.23 210.17 338.23 210.17 303.56 236.51 306.23 236.51 345.23",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.26 338.77 251 342.35 261.98 342.35 248.19 338.52 239.26 338.77",
    style: {
      fill: "#d4d4d4",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.51,306.23l-26.34-2.66v30.37a7.55,7.55,0,0,0,6.83-2.27c3.67-4.34,6-13.67,12.67-16,3.5-1.23,5.61-2,6.84-2.44Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.5,
    cy: 323.5,
    rx: 2.17,
    ry: 4.17,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-4--inject-15"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 432.84,
    cy: 236.74,
    r: 37,
    style: {
      fill: "#fff",
      stroke: "#C026D3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.81,246.84c-2.25,0-3.33-.81-3.81-1.8V231.36a11,11,0,0,0-7-10.25,3.55,3.55,0,0,0,.08-.73,3.48,3.48,0,0,0-3.48-3.48h-.9a3.49,3.49,0,0,0-3.41,4.13A11,11,0,0,0,423,231.36V245c-.48,1-1.55,1.8-3.81,1.8v3.81h11.22c0,.08,0,.15,0,.23a3.59,3.59,0,0,0,7.18,0c0-.08,0-.15,0-.23h11.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.49,
    y1: 255.57,
    x2: 462.48,
    y2: 214.56,
    style: {
      fill: "none",
      stroke: "#C026D3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-3--inject-15"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 326.75,
    cy: 181.56,
    r: 37,
    transform: "translate(-32.68 284.22) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#C026D3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.68,173.31a10.38,10.38,0,0,0-1.26.09,14.62,14.62,0,0,0-28.57-2.3A11,11,0,0,0,314.1,193h28.58a9.83,9.83,0,0,0,0-19.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.18 201.05 320.11 194 316.03 201.05 318.11 201.05 318.11 206.7 322.11 206.7 322.11 201.05 324.18 201.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.93 199.65 333 206.7 337.07 199.65 335 199.65 335 194 331 194 331 199.65 328.93 199.65",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.73,
    y1: 200.38,
    x2: 355.72,
    y2: 159.37,
    style: {
      fill: "none",
      stroke: "#C026D3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-2--inject-15"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 195.07,
    cy: 196.94,
    r: 37,
    transform: "translate(-39.49 49.22) rotate(-13.07)",
    style: {
      fill: "#fff",
      stroke: "#C026D3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.68,199.47a5,5,0,0,1,5-5h5.05V180.12a5.19,5.19,0,0,0-5.19-5.19H173a5.19,5.19,0,0,0-5.19,5.19v16a5.19,5.19,0,0,0,5.19,5.19h6.18l5.41,11.19,3-11.19h8.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.69,195.93h18.79a3.54,3.54,0,0,1,3.55,3.54v10.9a3.55,3.55,0,0,1-3.55,3.54h-4.2l-3.7,7.63-2-7.63h-8.86a3.54,3.54,0,0,1-3.54-3.54v-10.9A3.53,3.53,0,0,1,200.69,195.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.38,
    y1: 182.2,
    x2: 198.15,
    y2: 182.2,
    style: {
      fill: "none",
      stroke: "#C026D3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.38,
    y1: 187.79,
    x2: 198.15,
    y2: 187.79,
    style: {
      fill: "none",
      stroke: "#C026D3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.38,
    y1: 193.38,
    x2: 198.15,
    y2: 193.38,
    style: {
      fill: "none",
      stroke: "#C026D3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164,
    y1: 215.76,
    x2: 223.99,
    y2: 174.75,
    style: {
      fill: "none",
      stroke: "#C026D3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-1--inject-15"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.98,
    cy: 262.9,
    r: 37,
    transform: "translate(-158.66 142.75) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#C026D3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,248.69A30.45,30.45,0,0,0,77.26,253a63.12,63.12,0,0,0-5.65,4.16,3.65,3.65,0,0,1-3.5.85,3.22,3.22,0,0,1-1.82-4.72,8,8,0,0,1,1.4-1.57,37.42,37.42,0,0,1,21.4-9.48c11.19-1.12,20.91,2.29,29.34,9.6a4.05,4.05,0,0,1,1.69,2.76,3.27,3.27,0,0,1-5.19,3c-.66-.45-1.24-1-1.86-1.54a31,31,0,0,0-19.2-7.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.51,266.53a3.55,3.55,0,0,1-2.57-1.1,20,20,0,0,0-26.75-.94c-.56.46-1.1,1-1.7,1.39a3.28,3.28,0,0,1-4.44-.48,3.24,3.24,0,0,1,.11-4.4,24.58,24.58,0,0,1,9.5-6.14,26.2,26.2,0,0,1,20.72.86,25.21,25.21,0,0,1,7.4,5.16,3.26,3.26,0,0,1,.7,3.7A3.12,3.12,0,0,1,109.51,266.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.91,264.25a15.54,15.54,0,0,1,11.49,5,3.3,3.3,0,0,1,.14,4.52,3.36,3.36,0,0,1-4.63.29,17.25,17.25,0,0,0-3.67-2.47c-3.48-1.41-6.66-.62-9.43,1.86a3.94,3.94,0,0,1-3.44,1.34,3.23,3.23,0,0,1-2-5.18,13.61,13.61,0,0,1,5.6-4.11A15.64,15.64,0,0,1,92.91,264.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05,283.75a3.92,3.92,0,0,1-4-4,4,4,0,0,1,3.94-4,4,4,0,1,1,.09,7.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.9,
    y1: 281.72,
    x2: 121.89,
    y2: 240.71,
    style: {
      fill: "none",
      stroke: "#C026D3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoingofflineBro);
export default __webpack_public_path__ + "static/media/Going offline-bro.59df78f1972921b8ed819a4e4ab2a25e.svg";
export { ForwardRef as ReactComponent };